module.exports = __webpack_public_path__ + "img/IMG_0204-15_L_Foamcore.0e58d19d.jpg";